import { ApiResource } from '../model/api-resource.model';

export const loadedOrLoading = (resource: ApiResource): boolean => {
  return resource.data !== null || resource.loading;
}
